import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import actions from 'actions/locationGroups'
import Component from 'components/LocationCounts/EditCounts/Filter'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

export default connect(mapStateToProps, { getLocationGroups: actions.getItemsOffline })(Component)
